import { render, staticRenderFns } from "./comHome.vue?vue&type=template&id=2fedbccf&scoped=true&"
import script from "./comHome.vue?vue&type=script&lang=js&"
export * from "./comHome.vue?vue&type=script&lang=js&"
import style0 from "./comHome.vue?vue&type=style&index=0&id=2fedbccf&scoped=true&lang=css&"
import style1 from "./comHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fedbccf",
  null
  
)

export default component.exports